import React from 'react'

import { SideBarDataQuery } from '../../../hook/graphql/side-bar-data'
import LastestCard from '../lastest-card'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Flex, H2, Button } from '@dayancloud/common/components'
import { typography, color, hideLGDown } from '@dayancloud/common/theme'
import DemoGif from '../../../images/dayan-demo-2021-09.gif'

const SideBarContainer = styled.div`
  margin-bottom: 30px;
  ${hideLGDown};
`
const SideBarTitle = styled(H2)`
  margin-bottom: 20px;
  font-size: 20px;
  color: #333333;
  font-weight: 400;
`
const DemoContainer = styled(Flex)`
  width: 100%;
  height: 245px;
  background: #1f1f24;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
  background: url(${DemoGif}) no-repeat center center/100%;
  button {
    position: absolute;
    margin-bottom: 38px;
    border-radius: 20px;
  }
`
const CategoryContainer = styled(Flex)`
  justify-content: flex-start;
  flex-wrap: wrap;
  a {
    padding: 10px 20px;
    margin: 0 12px 10px 0;
    font-size: ${typography.textSmall};
    color: ${color.input};
    border: none;
    border-radius: 6px;
    background: #f2f2f6;
    :hover {
      color: #fff;
      background: ${color.primary};
    }
  }
`
const CategoryContainerTag = styled(Flex)`
  justify-content: flex-start;
  flex-wrap: wrap;
  a {
    margin: 0 6px 4px 0;
    font-size: 14px;
    color: #7d829c;
    line-height: 22px;
    :hover {
      color: ${color.primary};
    }
    :after {
      content: '|';
      margin-left: 6px;
    }
  }
`

function SideBar() {
  const data = SideBarDataQuery()
  return (
    <div>
      <SideBarContainer>
        <SideBarTitle>资讯分类</SideBarTitle>
        <CategoryContainer>
          {data.categories.nodes.map((node, index) => {
            return (
              <Link to={`/${node.slug}/`} key={index}>
                {node.name}
              </Link>
            )
          })}
        </CategoryContainer>
      </SideBarContainer>
      <SideBarContainer>
        <SideBarTitle>热门标签</SideBarTitle>
        <CategoryContainerTag>
          {data.tags.nodes.map((node, index) => {
            return (
              <Link to={`/${node.slug}/`} key={index}>
                {node.name}
              </Link>
            )
          })}
        </CategoryContainerTag>
      </SideBarContainer>
      <DemoContainer>
        <Button>体验demo</Button>
      </DemoContainer>
      <SideBarContainer>
        <SideBarTitle>最新资讯</SideBarTitle>
        {data.post.nodes.map((node, index) => {
          return (
            <LastestCard
              title={node.title}
              content={node.content.content}
              slug={node.slug}
              time={node.createdAt}
              key={index}
            />
          )
        })}
      </SideBarContainer>
    </div>
  )
}

export default SideBar
